/**
 * Read the reset token from an emailed link's fragment
 * (`#token=prt_….<secret>`, spec 0009 §5.6). Returns null when absent.
 */
export function readTokenFromHash(hash: string): string | null {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const token = params.get("token");
  return token ? token : null;
}
